/**
 * * @module pages/memberships.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import InPageLinks from "../components/inpage-links";

const OurStory = Backbone.View.extend({
  el: $(document),
  events: {
  },

  initialize: function () {
    this.render();
  },


  render: function () {
    const inPageLinks = new InPageLinks(".page-template-page-our-story");
  },
});

export default OurStory;
